import React from 'react';
import { connect } from 'react-redux';

import { withGilt, withTranslation } from 'providers/GILT.provider';

import ComingSoon from 'cashup/components/ComingSoon.component';
import ReportsMainLayoutContainer from 'reports/Common/ReportsMainLayout';
import { Tables } from 'reports/consts';
import { CashCardSplitClientTable } from 'reports/Payments/CashCardSplitClientTable';
import CashCardSplitStylistTable from 'reports/Payments/CashCardSplitStylistTable';

const ReportsProps = ['salesReport'];

class PaymentsLayout extends ReportsMainLayoutContainer {
  constructor(props) {
    super(props);
    this.state = {
      headerData: {
        name: props.t('businessReports.payments.title'),
        items: [
          {
            id: Tables.ClientVisitsFrequency,
            name: props.t('businessReports.payments.visitsFrequency'),
            onClick: () => {
              this.setTables(Tables.ClientVisitsFrequency);
            },
          },
          {
            id: Tables.CashCardSplitByClient,
            name: props.t('businessReports.payments.cashCardSplit'),
            onClick: () => {
              this.setTables(Tables.CashCardSplitByClient);
            },
          },
          {
            id: Tables.UniqueClientVisits,
            name: props.t('businessReports.payments.uniqueVisits'),
            onClick: () => {
              this.setTables(Tables.UniqueClientVisits);
            },
          },
        ],
      },
      title: '',
      shownTables: 0,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  checkIfAllDataIsLoaded = () => ReportsProps.every((prop) => this.props[prop].lastRequestResponse);

  render() {
    const { uniqueVisitsReport, formatDate } = this.props;
    return (
      <div className="has-protipbox payments">
        <ComingSoon variant="big" />
        <div className="new-wraper">
          {!this.checkIfAllDataIsLoaded() && (
            <div className="spinner-container">
              <div className="load-spinner" />
            </div>
          )}
          {this.props.salesReport.lastRequestResponse && (
            <div className="box">
              <div className="title">{`${this.state.title}`}</div>
              <CashCardSplitStylistTable
                startDate={formatDate(uniqueVisitsReport.start_date, { hideTime: true, hideWeekday: true })}
                endDate={formatDate(uniqueVisitsReport.end_date, { hideTime: true, hideWeekday: true })}
                dataCategory={this.props.salesReport.lastRequestResponse.category_group}
                dataProducts={this.props.salesReport.lastRequestResponse.product_group}
                stylists={this.props.salesReport.lastRequestResponse.stylist_group}
              />
              <CashCardSplitClientTable
                startDate={formatDate(uniqueVisitsReport.start_date, { hideTime: true, hideWeekday: true })}
                endDate={formatDate(uniqueVisitsReport.end_date, { hideTime: true, hideWeekday: true })}
                dataCategory={this.props.salesReport.lastRequestResponse.category_group}
                dataProducts={this.props.salesReport.lastRequestResponse.product_group}
                clients={this.props.salesReport.lastRequestResponse.client_group}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    currentSalon: { id: salonId },
    reports,
  } = state;
  const { salesReport, isFetching, uniqueVisitsReport } = reports;
  return {
    salonId,
    salesReport,
    isFetching,
    uniqueVisitsReport,
  };
}

export function mapDispatchToProps() {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(withGilt(withTranslation()(PaymentsLayout)));
